import React, { useContext, useState } from 'react';
import clsx from 'clsx';

import {
    IconButton,
    Typography,
    Button,
    Grid,
    Input,
    Paper,
    colors
} from '@material-ui/core';

import SearchIcon from '@material-ui/icons/Search';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';

import { makeStyles, withStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    search: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIcon: {
        marginRight: theme.spacing(2),
        color: theme.palette.icon
    },
    searchInput: {
        flexGrow: 1
    },
    searchButton: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
    searchAllign: {
        display: 'flex',
        alignItems: 'center'
    },
    addButton: {
        marginLeft: theme.spacing(1)
    },
    saveButton: {
        marginLeft: theme.spacing(1)
    },
    cancelButton: {
        marginLeft: theme.spacing(1)
    },
    actionButton1: {
        marginRight: theme.spacing(1)
    },
    actionButton2: {
        marginRight: theme.spacing(1)
    }
}));

const createColoredButton = (color) => withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(color[500]),
        backgroundColor: color[500],
        '&:hover': {
            backgroundColor: color[700],
        },
    },
}))(Button);

//const AddButton = createColoredButton(colors.gre)

export const PageHeader = ({
    title,
    subtitle,
    search,
    onSearchClick,
    add,
    addButtonText,
    onAddClick,
    save,
    saveButtonText,
    onSaveClick,
    cancel,
    cancelButtonText,
    onCancelClick,
    action1,
    action1ButtonText,
    onAction1Click,
    action2,
    action2ButtonText,
    onAction2Click,
    disabled,
    ...props
}) => {
    const classes = useStyles();

    const [searchText, setSearchText] = useState("");
    const searchClickHandler = () => {
        if (onSearchClick) onSearchClick(searchText);
    }

    const clearClickHandler = () => {
        setSearchText("");
        if (onSearchClick) onSearchClick("");
    }

    return (
        <div>
            <Grid
                alignItems="center"
                container
                justifyContent="space-between"
                className={clsx(classes.root, props.className)}>
                <Grid item>
                    <Typography
                        component="h2"
                        variant="overline">
                        {subtitle ?? "Subtitle"}
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h5"
                        gutterBottom>
                        {title ?? "Title"}
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid container>
                        {action1 &&
                            <Grid item>
                                <Button
                                    className={classes.actionButton1}
                                    color="default"
                                    onClick={onAction1Click}
                                    size="large"
                                    variant="contained"
                                    disabled={disabled}>
                                    {action1ButtonText ?? "Action 1"}
                                </Button>
                            </Grid>
                        }
                        {action2 &&
                            <Grid item>
                                <Button
                                    className={classes.actionButton2}
                                    color="default"
                                    onClick={onAction2Click}
                                    size="large"
                                    variant="contained"
                                    disabled={disabled}>
                                    {action2ButtonText ?? "Action 1"}
                                </Button>
                            </Grid>
                        }
                        {cancel &&
                            <Grid item>
                                <Button
                                    className={classes.cancelButton}
                                    color="secondary"
                                    onClick={onCancelClick}
                                    size="large"
                                    variant="contained"
                                    disabled={disabled}>
                                    {cancelButtonText ?? "Cancel"}
                                </Button>
                            </Grid>
                        }
                        {add &&
                            <Grid item>
                                <Button
                                    className={classes.addButton}
                                    color="primary"
                                    onClick={onAddClick}
                                    size="large"
                                    variant="contained"
                                    disabled={disabled}>
                                    {addButtonText ?? "Add New"}
                                </Button>
                            </Grid>
                        }
                        {save &&
                            <Grid item>
                                <Button
                                    className={classes.saveButton}
                                    color="primary"
                                    onClick={onSaveClick}
                                    size="large"
                                    variant="contained"
                                    disabled={disabled}>
                                    {saveButtonText ?? "Save Changes"}
                                </Button>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                container
                alignItems="flex-end"
                justifyContent="space-between"
                spacing={3}>
                {search &&
                    <Grid item>
                        <div className={classes.searchAllign}>
                            <Paper
                                className={classes.search}
                                elevation={1}>
                                <SearchIcon className={classes.searchIcon} />
                                <Input
                                    className={classes.searchInput}
                                    disableUnderline
                                    placeholder="Search"
                                    value={searchText}
                                    disabled={disabled}
                                    onChange={e => setSearchText(e.target.value)}
                                />
                                <IconButton
                                    size="small"
                                    disabled={disabled}
                                    onClick={() => clearClickHandler()}>
                                    <CloseRoundedIcon />
                                </IconButton>
                            </Paper>
                            <Button
                                className={classes.searchButton}
                                onClick={() => searchClickHandler()}
                                size="large"
                                variant="contained"
                                disabled={disabled}>
                                Search
                            </Button>
                        </div>
                    </Grid>
                }
            </Grid>
        </div>
    );
}